class CustomSwatch extends HTMLElement {
  constructor() {
    super();
    this.container = this.closest('main-product, product-card');
    const productJSONHTML = this.container.querySelector('[data-product-json]');
    this.productJSON = productJSONHTML ? JSON.parse(productJSONHTML.innerHTML) : null;
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.addEventListener('change', e => {
      if (e.target.closest('[type="radio"]')) {
        this.handleOptionChange();
      }
    });

    if (Shopify.currentCountry?.voltage) {
      this.updateVoltage();
      this.changeCountrySpecificVariantNA();
    } else {
      document.addEventListener('countrySelector:ready', () => {
        this.updateVoltage();
        this.changeCountrySpecificVariantNA();
      });
    }

    this.changeCountrySpecificVariantNA();
  }

  handleOptionChange() {
    const selectId = this.container ? this.container.querySelector('[name="id"]') : null;

    if (this.productJSON && selectId) {
      let option1 = this.container.querySelector('[data-index="option1"]:checked');
      let option2 = this.container.querySelector('[data-index="option2"]:checked');
      let option3 = this.container.querySelector('[data-index="option3"]:checked');

      const selectedValues = [
        {
          value: option1 ? option1.value : null,
          index: 'option1',
        },
        {
          value: option2 ? option2.value : null,
          index: 'option2',
        },
        {
          value: option3 ? option3.value : null,
          index: 'option3',
        },
      ];

      const variant = this.productJSON.variants.find(variant =>
        selectedValues.every(({value, index}) => value === variant[index]),
      );

      if (variant) {
        selectId.value = variant.id;
        selectId.dispatchEvent(new Event('change', {bubbles: true}));

        const voltage = variant.options
          .filter(option => !option.includes(Shopify.strings.plus))
          .find(option => [Shopify.strings.v110, Shopify.strings.v220].includes(option));

        if (voltage) {
          document.dispatchEvent(new CustomEvent('updateVoltage', {detail: {voltage}}));
        }
      }
    }
  }

  updateVoltage() {
    const voltage = Shopify.currentCountry?.voltage;
    const voltageHandle = toHandle(voltage);
    const voltageOption = this.querySelector(`[data-value="${voltageHandle}"]`);

    if (voltageOption) {
      voltageOption.setAttribute('checked', true);
      voltageOption.dispatchEvent(new Event('change', {bubbles: true}));
    }
  }

  changeCountrySpecificVariantNA() {
    const hasNA = this.productJSON.variants.some(({title}) => title.includes(Shopify.strings.na));

    if (!hasNA) {
      return;
    }

    const voltageContainer = this.container.querySelector('.option-voltage-container');
    const propPlug = this.container.querySelector('#propPlug');

    if (voltageContainer) {
      voltageContainer.style.display = 'none';
    }

    if (propPlug) {
      propPlug.remove();
    }
  }
}

class CustomSwatchVoltage extends CustomSwatch {
  constructor() {
    super();
    this.voltageSelect = this.querySelector('.option-voltage-select');
    this.voltageSelectList = this.querySelector('.option-voltage-select-list');
    this.voltageSelectOverlay = this.querySelector('.option-voltage-overlay');
    this.voltageSelectP = this.querySelector('.option-voltage-select-p');

    this._setupEventListeners();
  }

  _setupEventListeners() {
    document.addEventListener('updateVoltage', () => {
      if (this.querySelector('.voltage :checked')) {
        this.querySelector('.option-voltage-select-v').innerHTML = this.querySelector('.voltage :checked').value;
      }
    });

    if (this.voltageSelect) {
      this.voltageSelect.addEventListener('click', evt => {
        this.voltageSelectList.style.display = 'inline-block';
        this.voltageSelectOverlay.style.display = 'block';
      });
    }

    if (this.voltageSelectOverlay) {
      this.voltageSelectOverlay.addEventListener('click', evt => {
        this.voltageSelectList.style.display = 'none';
        this.voltageSelectOverlay.style.display = 'none';
      });
    }

    this.addEventListener('click', evt => {
      if (evt.target.closest('.product-plug li')) {
        const plug = evt.target.closest('.product-plug li').dataset.plugValue;
        this.updatePlug(plug);
      }
    });
  }

  updatePlug(plug) {
    const productPlugItem = this.querySelectorAll('.product-plug li');
    this.voltageSelect.dataset.plug = plug;
    this.voltageSelectP.innerHTML = plug;
    productPlugItem.forEach(el => el.classList.remove('active'));
    const plugItem = this.querySelector(`[data-plug-value="${plug}"]`);

    if (plugItem) {
      plugItem.classList.add('active');
    }

    document.dispatchEvent(new CustomEvent('updatePlug'));
  }
}

customElements.define('custom-swatch', CustomSwatch);
customElements.define('custom-swatch-voltage', CustomSwatchVoltage);
